(function () {
  'use strict';

  var toggle = document.getElementById('elxMenuToggle');
  var menu = document.getElementById('elxMobileMenu');

  function hydrateDeferredImages(scope) {
    if (!scope) return;
    scope.querySelectorAll('img.elx-deferred-img[data-src]').forEach(function (img) {
      var src = img.getAttribute('data-src');
      var srcset = img.getAttribute('data-srcset');
      if (srcset) {
        img.setAttribute('srcset', srcset);
        img.removeAttribute('data-srcset');
      }
      if (src) {
        img.setAttribute('src', src);
        img.removeAttribute('data-src');
      }
      img.classList.remove('elx-deferred-img');
    });
  }


  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('elx-mobile-menu-open', open);
    });
  }

  function activateMegaGroup(button) {
    if (!button) return;
    var mega = button.closest('.elx-mega');
    if (!mega) return;
    var group = button.getAttribute('data-group');
    mega.querySelectorAll('.elx-mega-side-btn').forEach(function (item) {
      item.classList.toggle('is-active', item === button);
    });
    mega.querySelectorAll('.elx-mega-group').forEach(function (panel) {
      var active = panel.getAttribute('data-group-panel') === group;
      panel.classList.toggle('is-active', active);
      if (active) hydrateDeferredImages(panel);
    });
  }

  function initMegaMenus(scope) {
    (scope || document).querySelectorAll('.elx-mega').forEach(function (mega) {
      if (mega.dataset.elxMega === 'true') return;
      mega.dataset.elxMega = 'true';
      var navItem = mega.closest('.elx-nav-item');
      if (navItem) {
        var warmActive = function () {
          var activePanel = mega.querySelector('.elx-mega-group.is-active');
          hydrateDeferredImages(activePanel);
        };
        navItem.addEventListener('mouseenter', warmActive, { once: true });
        navItem.addEventListener('focusin', warmActive, { once: true });
      }
      var first = mega.querySelector('.elx-mega-side-btn');
      if (first) {
        var firstGroup = first.getAttribute('data-group');
        mega.querySelectorAll('.elx-mega-side-btn').forEach(function (item) {
          item.classList.toggle('is-active', item === first);
        });
        mega.querySelectorAll('.elx-mega-group').forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-group-panel') === firstGroup);
        });
      }
      mega.querySelectorAll('.elx-mega-side-btn').forEach(function (button) {
        button.addEventListener('mouseenter', function () { activateMegaGroup(button); });
        button.addEventListener('focus', function () { activateMegaGroup(button); });
        button.addEventListener('click', function () {
          activateMegaGroup(button);
        });
      });
    });
  }

  function initMobileAccordions(scope) {
    (scope || document).querySelectorAll('.elx-mobile-nav-trigger').forEach(function (button) {
      if (button.dataset.elxBound === 'true') return;
      button.dataset.elxBound = 'true';
      button.addEventListener('click', function () {
        var item = button.closest('.elx-mobile-nav-item');
        if (!item) return;
        var parent = item.parentElement;
        if (parent) {
          parent.querySelectorAll('.elx-mobile-nav-item.is-open').forEach(function (other) {
            if (other === item) return;
            other.classList.remove('is-open');
            var otherButton = other.querySelector('.elx-mobile-nav-trigger');
            if (otherButton) otherButton.setAttribute('aria-expanded', 'false');
          });
        }
        var open = item.classList.toggle('is-open');
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) hydrateDeferredImages(item);
      });
    });
  }

  var cartRequest = null;
  function elxUpdateCartCount() {
    if (cartRequest) return cartRequest;
    cartRequest = fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart could not be loaded');
        return response.json();
      })
      .then(function (cart) {
        var counter = document.getElementById('elxCartCount');
        if (!counter) return;
        var quantity = Number(cart.item_count || 0);
        counter.textContent = quantity;
        counter.classList.toggle('is-zero', quantity <= 0);
      })
      .catch(function () {})
      .finally(function () { cartRequest = null; });
    return cartRequest;
  }

  document.addEventListener('cart:updated', elxUpdateCartCount);
  document.addEventListener('cart:refresh', elxUpdateCartCount);
  document.addEventListener('cart:change', elxUpdateCartCount);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) elxUpdateCartCount();
  });

  var warmedUrls = Object.create(null);

  function canWarmNavigation() {
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (connection && connection.saveData) return false;
    if (connection && /(^|-)2g$/.test(connection.effectiveType || '')) return false;
    return true;
  }

  function warmUrl(url) {
    if (!url || warmedUrls[url]) return;
    try {
      var parsed = new URL(url, location.href);
      if (parsed.origin !== location.origin) return;
      if (parsed.pathname.indexOf('/cart') === 0 ||
          parsed.pathname.indexOf('/account') === 0 ||
          parsed.pathname.indexOf('/search') === 0 ||
          parsed.pathname.indexOf('/checkout') === 0) return;
      if (parsed.search) return;

      warmedUrls[url] = true;
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = parsed.href;
      link.as = 'document';
      document.head.appendChild(link);
    } catch (e) {}
  }

  function warmPrimaryNavigation() {
    if (!canWarmNavigation()) return;
    var links = [].slice.call(document.querySelectorAll('.elx-header-nav > .elx-nav-item > .elx-header-nav-link'));
    var index = 0;

    function batch(deadline) {
      var count = 0;
      while (index < links.length && count < 3 && (!deadline || deadline.timeRemaining() > 2)) {
        warmUrl(links[index].href);
        index += 1;
        count += 1;
      }
      if (index < links.length) {
        if ('requestIdleCallback' in window) requestIdleCallback(batch, { timeout: 1400 });
        else setTimeout(function () { batch(); }, 650);
      }
    }

    if ('requestIdleCallback' in window) requestIdleCallback(batch, { timeout: 1200 });
    else setTimeout(function () { batch(); }, 900);
  }

  function init(scope) {
    initMegaMenus(scope || document);
    initMobileAccordions(scope || document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
      warmPrimaryNavigation();
    });
  } else {
    init(document);
    warmPrimaryNavigation();
  }
})();
